import React from 'react';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const TextFieldWithEraser = ({ onChange, regExp, xmlValuesDisabled, ...restProps }) => {
  
  const handleChange = (value) => {
    if (regExp) regExp.test(value) && onChange(value)
    else onChange(value);
  };

  return (
    <TextField
      onChange={({ target: { value } }) => handleChange(value)}
      {...(restProps.fullWidth && { sx: { width: '100%' } })}
      {...(restProps.value &&
        restProps.value !== '' && !xmlValuesDisabled && {
        InputProps: {
          endAdornment: ( 
            <InputAdornment position="end">
              <IconButton size="small" onClick={() => onChange('')} edge="end">
                <CloseIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ),
        },
      })}
      {...restProps}
    />
  );
}


